import { Plus } from "lucide-react";
import { Button } from "./beui/Button";

export const SUGGESTION_BUTTON_CLASS = "text-left text-xs rounded-lg border border-line px-3 py-2 hover:border-navy-500 hover:bg-navy-50 text-navy-600 disabled:opacity-50";

/** Shared controlled form inputs; callers retain validation and saved values. */

export { SmartSelect } from "./SmartSelect";
export { TagPicker } from "./TagPicker";

export function SuggestField({
  value, onChange, suggestions, placeholder, id, maxLength, invalid, describedBy,
}: {
  value: string;
  onChange: (v: string) => void;
  suggestions: string[];
  placeholder?: string;
  id?: string;
  maxLength?: number;
  invalid?: boolean;
  describedBy?: string;
}) {
  const normalizedValue = value.toLocaleLowerCase();
  function appendedValue(snippet: string) {
    const base = value.trim();
    return base ? `${base}\n${snippet}` : snippet;
  }
  function apply(snippet: string) {
    if (normalizedValue.includes(snippet.trim().toLocaleLowerCase())) return;
    const nextValue = appendedValue(snippet);
    if (maxLength !== undefined && nextValue.length > maxLength) return;
    onChange(nextValue);
  }
  const seen = new Set<string>();
  const openSuggestions = suggestions.filter((snippet) => {
    const key = snippet.trim().toLocaleLowerCase();
    if (!key || seen.has(key) || normalizedValue.includes(key)) return false;
    seen.add(key);
    return true;
  });
  return (
    <div>
      <textarea id={id} maxLength={maxLength} className={`field h-28 py-2 ${invalid ? "border-brand-red" : ""}`} aria-invalid={invalid || undefined} aria-describedby={describedBy} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder || "Describe your post in detail…"} />
      {openSuggestions.length > 0 && (
        <div className="mt-2">
          <p className="posting-helper text-[11px] text-mut mb-1.5">Suggestions</p>
          <div className="flex flex-wrap gap-2">
            {openSuggestions.map((s) => (
              <Button key={s} variant="outline" size="sm" onClick={() => apply(s)} disabled={maxLength !== undefined && appendedValue(s).length > maxLength} className="min-h-11 h-auto max-w-full justify-start whitespace-normal rounded-lg border-line bg-white py-2 text-left text-xs leading-relaxed text-navy focus-visible:outline focus-visible:outline-2 focus-visible:outline-navy focus-visible:outline-offset-2">
                <Plus className="h-3.5 w-3.5 shrink-0 text-brand-red" aria-hidden="true" />{s}
              </Button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
